import styled, { css } from 'styled-components'

import { PairInformationCurrency } from '@root/entities/pair/ui'
import { PairIcon } from '@root/entities/pair/ui/common'

import { PairInformationPool } from '../pair-information/pair-information-pool'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type PairInformationProps = {
  pair: PairModel
  onAuditClick?: () => void
} & ClassNameProps

export const PairInformationShort: React.FC<PairInformationProps> = ({
  className,
  pair,
  onAuditClick,
}) => {
  return (
    <PairInformationShortRoot className={className}>
      <PairIcon
        size={36}
        pair={pair}
        withNetwork
        providerSize={14}
        withPairPopover
      />
      <PairInformationCurrency
        pair={pair}
        css={css`
          padding-inline-start: 10px;
          --pair-ticker-font-size: 14px;
        `}
      />
      <PairInformationPool
        onAuditClick={onAuditClick}
        pair={pair}
        css={css`
          --pool-item-gap: 14px;
        `}
      />
    </PairInformationShortRoot>
  )
}

const PairInformationShortRoot = styled.div`
  border-bottom: 1px solid var(--background-2);

  height: 60px;
  display: grid;
  justify-items: start;
  align-items: center;
  grid-template-columns: auto 1fr auto;
  padding-inline: 12px 16px;
`
